const menuWithSubmenu = document.querySelectorAll( '.mobile-menu .menu-item-has-children' );
menuWithSubmenu.forEach( ( menu ) => menu.addEventListener( 'click', classToggle ) );

function classToggle( e ) {
  e.currentTarget.classList.toggle( 'menu-item-has-children--active' );
}
